<template>
  <div style=" width:40vw; margin:0 auto;" class="content-form">
    <div class="field">
      <label for="target" class="label">Enviar a</label>
      <select id="target" v-model="target" class="input width-full">
        <option value="todos">Todos los usuarios de la app</option>
        <option v-for="station in stations" :key="station.id" :value="station.id">
          Oyentes de {{ station.name }}
        </option>
      </select>
      <p class="help">"Oyentes de" una emisora: dispositivos donde es la emisora más escuchada.</p>
    </div>

    <div class="field">
      <span class="label">Enviar por</span>
      <label class="checkbox notification-channel">
        <input v-model="channels" type="checkbox" value="firebase" />
        Firebase: app nueva
      </label>
      <label :class="['checkbox', 'notification-channel', { 'is-disabled': target !== 'todos' }]">
        <input v-model="channels" type="checkbox" value="onesignal" :disabled="target !== 'todos'" />
        OneSignal: app anterior (1.78) y avisos web de madradio.co
      </label>
      <p class="help">OneSignal solo envía a todos (no distingue emisoras) y le llega también a quienes aceptaron avisos en la web.</p>
    </div>

    <div class="field">
      <label for="title" class="label">Título (opcional)</label>
      <input id="title" v-model="title" class="input width-full" type="text" maxlength="100" placeholder="Mad Radio" />
    </div>

    <div class="field">
      <label for="message" class="label">Mensaje</label>
      <textarea
        id="message"
        rows="20"
        class="input width-full"
        style="width:1000px; height:200px"
        maxlength="1000"
        v-model="message"
      ></textarea>
    </div>
    <div class="field">
      <a class="button width-full" :disabled="sending" @click="enviar()">{{ sending ? "Enviando…" : "Enviar" }}</a>
    </div>
    <p v-if="status" :class="['notification-status', status.ok ? 'is-ok' : 'is-error']">{{ status.text }}</p>
  </div>
</template>

<script>
import axios from 'axios'
import { auth, db } from '../../services/firebase-init'

// Session restored by Firebase after a reload (currentUser is null until then).
function currentUser () {
  return new Promise(resolve => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      unsubscribe()
      resolve(user)
    })
  })
}

export default {
  name: 'notifications',
  data () {
    return {
      target: 'todos',
      channels: ['firebase'],
      title: '',
      message: '',
      stations: [],
      sending: false,
      status: null
    }
  },
  created () {
    this.stationsRef = db.ref('/form/stations')
    this.stationsRef.on('value', snapshot => {
      const value = snapshot.val() || {}
      this.stations = Object.keys(value)
        .filter(key => value[key] && value[key].name)
        .map(key => ({ id: String(value[key].id || key), name: value[key].name }))
    })
  },
  beforeDestroy () {
    this.stationsRef.off()
  },
  watch: {
    target (value) {
      if (value !== 'todos') this.channels = this.channels.filter(c => c !== 'onesignal')
    }
  },
  methods: {
    targetLabel () {
      if (this.target === 'todos') return 'todos los usuarios de la app'
      const station = this.stations.find(s => s.id === this.target)
      return 'los oyentes de ' + (station ? station.name : 'la emisora')
    },
    confirmText (message) {
      const lines = []
      if (this.channels.indexOf('firebase') !== -1) lines.push('- Firebase: ' + this.targetLabel() + ' (app nueva)')
      if (this.channels.indexOf('onesignal') !== -1) lines.push('- OneSignal: app anterior y avisos web de madradio.co')
      return '¿Enviar esta notificación?\n' + lines.join('\n') + '\n\n' + message
    },
    resultText (results) {
      const names = { firebase: 'Firebase', onesignal: 'OneSignal' }
      return this.channels
        .filter(c => results[c])
        .map(c => names[c] + ': ' + (results[c].ok ? 'enviada' : 'no se pudo enviar (' + results[c].error + ')'))
        .join('. ') + '.'
    },
    async enviar () {
      const message = this.message.trim()
      if (this.sending) return
      if (!message) {
        this.status = { ok: false, text: 'Escribe el mensaje antes de enviar.' }
        return
      }
      if (!this.channels.length) {
        this.status = { ok: false, text: 'Elige al menos un medio de envío.' }
        return
      }
      if (!window.confirm(this.confirmText(message))) return

      this.sending = true
      this.status = null
      try {
        const user = await currentUser()
        if (!user) throw new Error('La sesión venció: vuelve a iniciar sesión.')
        const token = await user.getIdToken()
        const { data } = await axios.post(
          '/api/push',
          { target: this.target, title: this.title.trim(), message, channels: this.channels },
          { headers: { Authorization: 'Bearer ' + token } }
        )
        this.status = { ok: data.ok, text: this.resultText(data.results || {}) }
        if (data.ok) {
          this.message = ''
          this.title = ''
        }
      } catch (error) {
        const data = (error.response && error.response.data) || {}
        const text = data.results ? this.resultText(data.results) : 'No se pudo enviar: ' + (data.error || error.message)
        this.status = { ok: false, text }
      } finally {
        this.sending = false
      }
    }
  }
}
</script>

<style type="text/css">
.notification-status {
  margin-top: 1em;
  font-weight: bold;
}
.notification-status.is-ok {
  color: #2e7d32;
}
.notification-status.is-error {
  color: #c62828;
}
.notification-channel {
  display: block;
  margin: 0.3em 0;
}
.notification-channel.is-disabled {
  opacity: 0.5;
}
</style>
